import { TextField } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab"
import { useSelector, useDispatch } from "react-redux"
import { addCategoriaAction, obtenerCategoriasAction} from "../../../ducks/cambiosClaveViaje"
import handleRenderOption from "./handleRenderOption"
import { useEffect } from "react"
const InitialValueCategoria = {
    Nombre: "",
    IdCategoriaPaquete: 0,
}

const CbCategoria = () => {
    const { listaCategoria, categoria } = useSelector(store => store.cambiosGrupales)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerCategoriasAction())
    }, [dispatch])
    const getOptionHangle = (event, valor) => {
        if (valor) {
            dispatch(addCategoriaAction({ categoria: valor }))
        } else {
            dispatch(addCategoriaAction({ categoria: InitialValueCategoria }))

        }
    }
    return (
        <div style={{ margin: "2% 0" }}>
            <Autocomplete
                value={categoria}
                id={`id-auto-Categorias`}
                options={listaCategoria.sort((a, b) => a.Nombre > b.Nombre)}
                getOptionLabel={(option) => {
                    return `${option.Nombre}`
                }}
                style={{
                    width: "97%",
                    margin: "2% 0",
                    paddingBottom: "0",
                    fontWeight: "500",
                }}
                disabled={listaCategoria.length > 0 ? false : true}
                onChange={getOptionHangle}
                renderInput={(params) => {
                    return (
                        <TextField
                            {...params}
                            label="Categoria"
                            variant="outlined"
                            style={{ width: "100%" }}
                            name="categoria"
                        />
                    )
                }}
                renderOption={handleRenderOption}
            />
        </div>
    )
}
export default CbCategoria